import { useDispatch } from "react-redux";
import * as TC from "../thunkCreators";
import { X2yController } from "../types";

const { isArray } = Array;

const createUseFetchX2yCallback = (controller: X2yController) => {
  const thunkCreator = TC.createFetchThunk({ controller });
  const bulkThunkCreator = TC.createBulkFetchThunk({ controller });

  return () => {
    const dispatch = useDispatch();

    function callback(xIdOrIds: number | number[]) {
      return Promise.resolve().then(() => {
        // Nechci testovat pro arr.length === 1, protože by to imo mátlo v redux dev tools,
        // chci dispatchovat bulk akci pro bulk operace, i když jsem vybral jenom 1 možnost
        const singleIdMode = !isArray(xIdOrIds);

        if (singleIdMode) {
          const xId = xIdOrIds as number;
          dispatch(thunkCreator({ xId }));
          return;
        }

        const xIds = xIdOrIds as number[];
        dispatch(bulkThunkCreator({ xIds }));
      });
    }

    return callback;
  };
};

export default createUseFetchX2yCallback;
